<template>
  <div class="purchase-list-footer">
    <Button variant="inverse" to="/offer/material-list">
      <template v-slot:icon-left>
        <ArrowLeftSVG class="icon button__icon-animate" />
      </template>
      {{ $t('OFFER.TO_MATERIAL') }}
    </Button>

    <Button
      variant="inverse"
      @click="delegateDownload"
      :loading="isDownloading"
    >
      <template v-slot:icon-left>
        <PdfIconSVG class="icon" />
      </template>
      {{ $t('OFFER.DOWNLOAD_PDF') }}
    </Button>

    <Button
      v-if="$i18n.locale === 'sv'"
      :href="redirectUrl"
      target="_blank"
      :disabled="isGetRedirectUrlLoading"
    >
      {{ $t('SHOP.GO_TO_SHOP') }}
      <template v-slot:icon-right>
        <ArrowRightSVG class="icon button__icon-animate" />
      </template>
    </Button>

    <Button
      v-if="showQuoteRequest"
      @click="openLeadForm"
      :disabled="quoteRequestSent"
    >
      {{ quoteRequestSent ? $t('LEAD_FORM.SENT') : $t('OFFER.MAILTO_BUTTON') }}
    </Button>

    <LeadDetailsModal
      v-if="showQuoteRequest"
      :visible="isLeadFormVisible"
      :is-submitting="isQuoteRequestLoading"
      :submit-error="quoteRequestError"
      @submit="submitQuoteRequest"
      @cancel="closeLeadForm"
    />
  </div>
</template>

<script>
import Button from '@/components/Button';
import LeadDetailsModal from '@/components/offer/purchase-list/LeadDetailsModal';
import PdfIconSVG from '@/assets/images/offer/pdf-icon.svg?inline';
import ArrowLeftSVG from '@/assets/images/icon-long-arrow-alt-left-solid.svg?inline';
import ArrowRightSVG from '@/assets/images/icon-long-arrow-alt-right-solid.svg?inline';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'PurchaseListFooter',
  data() {
    return {
      isLeadFormVisible: false,
    };
  },
  components: {
    Button,
    PdfIconSVG,
    ArrowLeftSVG,
    ArrowRightSVG,
    LeadDetailsModal,
  },
  methods: {
    ...mapActions(['getRedirectUrl', 'sendQuoteRequest']),
    delegateDownload() {
      this.$emit('downloadPdf');
    },
    openLeadForm() {
      this.isLeadFormVisible = true;
    },
    closeLeadForm() {
      this.isLeadFormVisible = false;
    },
    async submitQuoteRequest(leadDetails) {
      const sent = await this.sendQuoteRequest(leadDetails);
      if (sent) {
        this.isLeadFormVisible = false;
      }
    },
  },
  computed: {
    ...mapState([
      'isDownloading',
      'isGetRedirectUrlLoading',
      'redirectUrl',
      'customerType',
      'isQuoteRequestLoading',
      'quoteRequestError',
      'quoteRequestSent',
    ]),
    showQuoteRequest() {
      return this.$i18n.locale === 'sv' && this.customerType === 'legal';
    },
  },
  mounted() {
    if (this.$i18n.locale === 'sv') {
      this.getRedirectUrl();
    }
  },
};
</script>

<style lang="scss">
.purchase-list-footer {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  justify-content: flex-end;

  @include min-width(md) {
    justify-content: flex-end;
    grid-auto-flow: column;
    grid-auto-columns: auto;
    transform: translateY(1.5rem);
  }

  @include min-width(lg) {
    transform: translateY(1.5rem);
    grid-auto-flow: column;
    grid-auto-columns: auto;
  }
}
</style>
